const FALLBACK_TIME = "00:00";
const NOON_HOUR = 12;
const PAD_LENGTH = 2;
const PAD_CHAR = "0";
const PARSE_RADIX = 10;
export const timePanel = {
    0: "departureTime",
    1: "arrivalTime",
    2: "completionTime"
};
export const get24hrFormatTime = (time, amPm) => {
    if (!time?.includes(":")) {
        return FALLBACK_TIME; // fallback for invalid time
    }
    const timeParts = time.split(":");
    const hours = Number.parseInt(timeParts[0], PARSE_RADIX);
    const minutes = Number.parseInt(timeParts[1], PARSE_RADIX);
    if (Number.isNaN(hours) || Number.isNaN(minutes)) {
        return FALLBACK_TIME; // fallback for invalid numbers
    }
    let adjustedHours = hours;
    if (amPm === "PM" && hours < NOON_HOUR) {
        adjustedHours += NOON_HOUR;
    }
    if (amPm === "AM" && hours === NOON_HOUR) {
        adjustedHours = 0;
    }
    return `${adjustedHours.toString().padStart(PAD_LENGTH, PAD_CHAR)}:${minutes.toString().padStart(PAD_LENGTH, PAD_CHAR)}`;
};
export const prepareFutureChargeOptionsRequestBody = (assetId, projectId, time, timeUnits, timePanelActiveIndex) => {
    if (time) {
        const selectedTime = get24hrFormatTime(time, timeUnits);
        const today = new Date();
        const day = today.getDate().toString().padStart(PAD_LENGTH, PAD_CHAR);
        const month = (today.getMonth() + 1).toString().padStart(PAD_LENGTH, PAD_CHAR);
        const year = today.getFullYear();
        const todayFormatted = `${year}-${month}-${day}`;
        const timestamp = todayFormatted + "T" + selectedTime;
        const requestBody = {
            assets: assetId,
            projectId: projectId
        };
        const timeKey = timePanel[timePanelActiveIndex] ?? "completionTime";
        requestBody[timeKey] = timestamp;
        return requestBody;
    }
};
